import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { Modal } from "@circleco/compass/components/Modal";

import { PlansModalBody } from "./PlansModalBody";
import type { PlansModalProps } from "./PlansModalBody";

export const PlansModalCompass = (props: PlansModalProps) => {
  const modal = useModal();

  const onOpenChange = async (open: boolean) => {
    if (!open) {
      await modal.hide();
      modal.remove();
    }
  };

  return (
    <Modal.Root
      open={modal.visible}
      onOpenChange={onOpenChange}
      size="full-width"
    >
      <Modal.Content>
        <Modal.Header title="" />
        <Modal.Body>
          <PlansModalBody {...props} />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
